<template>
  <b-modal
    :id="'modal' + opportunity.id"
    size="lg"
    centered
    :ref="'modal' + opportunity.id"
    no-fade
    hide-header
    hide-footer
    modal-class="modal-job-box"
  >
    <dl class="modal-container">
      <slot name="fullColor" class="fullcolor-container" />

      <dt class="modal-opportunity-title">
        <wheelchair-accessibility-icon
          class="wheelchair-accessibility-icon"
          v-if="opportunity.pcd"
          v-b-tooltip.hover="'Pessoas com Deficiência (PCD)'"
        />
        {{ title }}

        <b-btn
          variant="btn btn-transparent"
          @click="hideModal('modal' + opportunity.id)"
          class="close-btn"
        >
          <close-icon class="close-icon" />
        </b-btn>
      </dt>

      <dd class="close-btn-container">
        <b-btn
          variant="btn btn-transparent"
          @click="hideModal('modal' + opportunity.id)"
          class="close-btn"
        >
          <close-icon class="close-icon" />
        </b-btn>
      </dd>

      <dt class="modal-opportunity-address-title" v-if="opportunity.address">
        <map-marker-icon class="map-marker-icon" />
        Endereço
      </dt>

      <dd class="modal-opportunity-address-container" v-if="opportunity.address">
        <div>
          <h6>
            {{ opportunity.acting_mode
            }}<span v-if="opportunity.address"
              >,
              {{ this.$helpers.toTitle(opportunity.address.city + " - ") }}
              {{ opportunity.address.state ? opportunity.address.state.abbr : '' }} <br />
              <small
                class="modal-opportunity-address-street"
                v-if="opportunity.address.street"
                >{{ opportunity.address.street.toLowerCase() }}</small
              >
              <small v-if="opportunity.address.number"
                >, {{ opportunity.address.number }}</small
              >
              <small v-if="opportunity.address.neighborhood">
                - {{ opportunity.address.neighborhood.toLowerCase() }}</small
              >
            </span>
          </h6>
        </div>
      </dd>

      <dt
        class="modal-opportunity-responsability-title"
        v-if="opportunity.responsability"
      >
        Responsabilidades
      </dt>

      <dd
        class="modal-opportunity-responsability-container"
        v-if="opportunity.responsability"
      >
        <div v-html="opportunity.responsability"></div>
      </dd>

      <dt
        class="modal-opportunity-requirement-title"
        v-if="opportunity.requirement"
      >
        Requisitos
      </dt>
      <dd
        class="modal-opportunity-requirement-container"
        v-if="opportunity.requirement"
      >
        <div v-html="opportunity.requirement"></div>
      </dd>

      <dt
        class="modal-opportunity-work_environment-title"
        v-if="opportunity.work_environment"
      >
        Como é o ambiente de trabalho?
      </dt>
      <dd
        class="modal-opportunity-work_environment-container"
        v-if="opportunity.work_environment"
      >
        <div v-html="opportunity.work_environment"></div>
      </dd>

      <dt
        class="modal-opportunity-benefits-title"
        v-if="opportunity.benefits.length"
      >
        Benefícios
      </dt>
      <dd
        class="modal-opportunity-benefits-container"
        v-if="opportunity.benefits.length"
      >
        <div>
          <span
            class="benefits-list-container"
            v-for="benefit in opportunity.benefits"
          >
            <span
              class="benefits-name-list-container"
              :class="benefit.icon"
            ></span>
            {{ benefit.name }}
          </span>
        </div>
      </dd>

      <dt
        class="modal-opportunity-other_benefit-title"
        v-if="opportunity.other_benefit"
      >
        Observações e/ou Benefícios Adicionais
      </dt>
      <dd
        class="modal-opportunity-other_benefit-container"
        v-if="opportunity.other_benefit"
      >
        <div class="html-opportunity-other_benefit-container" v-html="opportunity.other_benefit"></div>
      </dd>

      <dt class="modal-opportunity-diversity-title">Diversidade</dt>
      <dd class="modal-opportunity-diversity-container">
        <div>
          <p>
            Nossos valores nos unem e nossas diferenças nos potencializam como
            um grupo.
          </p>
          <p>
            Mais do que igualdade, buscamos equidade: Aqui, temos espaço para
            sermos autênticos, independentemente de gênero, etnia, raça,
            orientação sexual, credo ou deficiência.
          </p>
        </div>
      </dd>

      <dt class="modal-footer-container"></dt>
      <dd class="modal-footer-btn-container">
        <div>
          <b-btn
            @click="hideModal('modal' + opportunity.id)"
            class="modal-footer-btn-close"
            >Fechar</b-btn
          >

          <router-link
            v-if="subscriptionStep == 'lead'"
            :to="customSubscriptionPageRoute ? customSubscriptionPageRoute : '/vagas/' + opportunity.slug + '/inscricao'"
            class="modal-footer-btn-subscription btn-continue-subscription"
          >
            Continuar Inscrição
          </router-link>
          <router-link
            v-else
            :to="customSubscriptionPageRoute ? customSubscriptionPageRoute : '/vagas/' + opportunity.slug + '/inscricao'"
            class="modal-footer-btn-subscription"
            :class="[ subscriptionStep == 'applied' ? 'modal-footer-btn-subscription-enrolled'
                : 'modal-footer-btn-subscription-not-enrolled', ]"
          >
            {{ subscriptionStep == 'applied' ? "Você já está inscrito" : btnSubscriptionText || "QUERO ME INSCREVER!" }}
          </router-link>

        </div>
      </dd>
    </dl>
  </b-modal>
</template>

<script>
import MapMarkerIcon from "vue-material-design-icons/MapMarker.vue";
import WheelchairAccessibilityIcon from "vue-material-design-icons/WheelchairAccessibility.vue";
import CloseIcon from "vue-material-design-icons/Close.vue";

export default {
  name: "ModalJobBox",

  props: {
    opportunity: Object,
    id: Number,
    btnSubscriptionText: String,
    customSubscriptionPageRoute: String,
  },

  computed: {
    title() {
      return this.opportunity.title;
    },

    subscriptionStep() {
      const id = this.opportunity.id;
      const findSubscription = this.$store.state.opportunities.subscriptions.find(
        (subs) => subs.opportunityId == id
      );

      if (findSubscription) {
        return findSubscription.step;
      }

      return '';
    },

    enrolled() {
      const uri = this.opportunity.links.subscription.split("/");
      const name = uri[uri.length - 1];
      const id = name.match(/\d+/)[0];
      return !!this.$store.state.opportunities.subscriptions.find(
        (subs) => subs.opportunityId == id
      );
    },
  },

  components: {
    WheelchairAccessibilityIcon,
    CloseIcon,
    MapMarkerIcon,
  },

  methods: {
    hideModal(ref) {
      this.$refs[ref].hide();
    },
  },
};
</script>

<style lang="scss">
.job-box {
  .modal-job-box-wrapper .modal-container .modal-footer-btn-container div .modal-footer-btn-subscription.btn-continue-subscription{
    background-color: #3FCB2A;
    &:hover{
      background-color: #37bd22;
    }
  }
}
</style>